const CANCELLATION_POLICY = `\n\n**Important Notice: Golf Lesson Cancellation Policy   
Cancellation Policy: 24 Hour**   
If, for any reason, you need to cancel your scheduled golf lesson, please note that cancellations must be made at least 24 hours in advance to be eligible for a refund. Cancellations made within 24 hours of the lesson will not be refunded. 
Once a multi session coaching series starts, the PGA Coaching Center does not offer any makeups, rainchecks or refunds.`

export { CANCELLATION_POLICY }
